import React from "react";
import classes from "./style/Crazy.module.css";

const Crazy = () => {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.circle}></div>
        <div className={classes.circle}></div>
        <div className={classes.circle}></div>
        <div className={classes.circle}></div>
      </div>
    </div>
  );
};

export default Crazy;
